/********
 *
 * 通用数据文件
 *
 */

// 推荐用户类型
export const pushUserType = [
  {
    value: '1',
    label: '学生',
  },
  {
    value: '2',
    label: '教师',
  },
  {
    value: '3',
    label: '家长',
  },
];

// 所有操作系统
export const operatingSystem = [
  {
    value: '1',
    label: 'IOS',
  },
  {
    value: '2',
    label: '安卓',
  },
  {
    value: '3',
    label: '鸿蒙',
  },
  {
    value: '4',
    label: 'PC',
  },
];
// 手机端操作系统
export const operatingSystemPhone = [
  {
    value: '1',
    label: 'IOS',
  },
  {
    value: '2',
    label: '安卓',
  },
  {
    value: '3',
    label: '鸿蒙',
  },
];

//跳转类型
export const jumpType = [
  {
    value: '1',
    label: 'url',
  },
  {
    value: '2',
    label: '小程序',
  },
  {
    value: '3',
    label: '文章',
  },
  {
    value: '4',
    label: '频道',
  },
  {
    value: '5',
    label: '视频课程',
  },
  {
    value: '6',
    label: '直播',
  },
];
//审核状态
export const auditStatus = [
  {
    value: '0',
    label: '待审核',
  },
  {
    value: '1',
    label: '审核中',
  },
  {
    value: '2',
    label: '已审核',
  },
  {
    value: '3',
    label: '审核失败',
  },
];
//性别
export const sexList = [
  {
    value: '2',
    label: '女',
  },
  {
    value: '1',
    label: '男',
  },
];
//状态
export const statusList = [
  {
    value: '0',
    label: '待上线',
  },
  {
    value: '1',
    label: '已上线',
  },
  {
    value: 2,
    label: '已下线',
  },
];
//状态
export const liveStatusList = [
  {
    value: '0',
    label: '未开始',
  },
  {
    value: '1',
    label: '直播中',
  },
  {
    value: '2',
    label: '已结束',
  },
];
//频道类型
export const channelType = [
  {
    value: '1',
    label: '基础频道',
  },
  {
    value: '2',
    label: '文章频道',
  },
  {
    value: '3',
    label: '课程频道',
  },
  {
    value: '4',
    label: '直播频道',
  },
];
//频道类型
export const messageType = [
  {
    value: '1',
    label: '系统消息',
  },
  {
    value: '2',
    label: '伴学助手',
  },
  {
    value: '3',
    label: '教育文章',
  },
];
//内容类型
export const contentType = [
  {
    value: '1',
    label: '文字',
  },
  {
    value: '2',
    label: '富文本',
  },
];
//敏感词类型
export const sensitiveType = [
  {
    value: '0',
    label: '政治敏感词',
  },
  {
    value: '1',
    label: '暴力恐怖词',
  },
  {
    value: '2',
    label: '低俗色情词',
  },
  {
    value: '3',
    label: '违法欺诈词',
  },
];
//按钮类型
export const buttonType = [
  {
    value: '1',
    label: 'banner',
  },
  {
    value: '2',
    label: '金刚区',
  },
];
export const resourcesList = [
  { label: '视频', value: 1 },
  { label: '音频', value: 2 },
  { label: '压缩包', value: 3 },
  { label: '图片', value: 4 },
  { label: '文档', value: 5 },
  { label: '文本', value: 6 },
];
export const delList = [
  { label: '3天内', value: 3 },
  { label: '5天内', value: 5 },
  { label: '7天内', value: 7 },
];
// 推广位类型
export const spreadSpaceType = [
  { label: 'banner', value: 0 },
  { label: '金刚区', value: 1 },
  { label: '直播', value: 2 },
  { label: '文章列表', value: 3 },
  { label: '文章单类目', value: 9 },
  // { label: '文章专题', value: 4 },
  { label: '文章多类目', value: 5 },
  { label: '强推课程', value: 6 },
  { label: '分类课程', value: 7 },
  { label: '课程列表', value: 8 },
  { label: '课文列表', value: 10 },
];
//课程类型
export const courseType = [
  { label: '音视频课程', value: 1 },
  { label: '学练测', value: 2 },
  { label: '闯关课', value: 3 },
];
//留言类型
export const wordType = [
  {
    value: '0',
    label: '全部留言',
  },
  {
    value: '1',
    label: '已发布',
  },
  {
    value: '2',
    label: '已置顶',
  },
];
//最近时间
export const lastTime = [
  {
    value: '10',
    label: '最近10天',
  },
  {
    value: '15',
    label: '最近半个月',
  },
  {
    value: '30',
    label: '最近一个月',
  },
];
//留言类型
export const learnList = [
  {
    value: 1,
    label: '顺序解锁',
  },
  {
    value: 2,
    label: '全部解锁',
  },
];
